import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const MinimumAgeValidator = z.literal('minimumAge');
export type TMinimumAgeValidator = z.infer<typeof MinimumAgeValidator>;

export const MinimumAgeValidatorParamsSchema = z.object({
  minimumAge: z.number(),

  //strict validation includes days and months in to the calculation
  strict: z.boolean().optional(),
});

export type TMinimumAgeValidatorParams = z.infer<typeof MinimumAgeValidatorParamsSchema>;

export const MinimumAgeValidatorSchema = BaseValidatorSchema.extend({
  type: MinimumAgeValidator,
  value: MinimumAgeValidatorParamsSchema,
});
